(function(){
  document.querySelectorAll('.pxb [data-pxb-track]').forEach(function(w){
    var t=w.querySelector('.pxb-track');if(!t||t.dataset.on)return;t.dataset.on='1';
    var items=[].slice.call(t.children),p=w.querySelector('.pxb-arw.p'),n=w.querySelector('.pxb-arw.n'),d=w.querySelector('.pxb-dots'),dots=[];
    function step(){return items.length>1?items[1].offsetLeft-items[0].offsetLeft:t.clientWidth;}
    if(d){items.forEach(function(it,i){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Show item '+(i+1));b.addEventListener('click',function(){t.scrollTo({left:it.offsetLeft-items[0].offsetLeft,behavior:'smooth'});});d.appendChild(b);dots.push(b);});}
    function upd(){
      var over=t.scrollWidth>t.clientWidth+4,end=t.scrollLeft+t.clientWidth>=t.scrollWidth-4;
      if(p)p.disabled=!over||t.scrollLeft<4;
      if(n)n.disabled=!over||end;
      if(d){d.hidden=!over;var i=end?items.length-1:Math.round(t.scrollLeft/step());dots.forEach(function(b,j){b.classList.toggle('on',j===i);});}
    }
    if(p)p.addEventListener('click',function(){t.scrollBy({left:-step(),behavior:'smooth'});});
    if(n)n.addEventListener('click',function(){t.scrollBy({left:step(),behavior:'smooth'});});
    t.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);upd();
  });
})();